
import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';

var displayModel = {

    getDisplaysList: function (successCallBack, failureCallBack, projectId, searchQuery, pageIndex, pageSize) {
        var path = '/api/objectdetection/projects/' + projectId + '/displays' + '?SearchQuery='+ searchQuery + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getDisplay: function (successCallBack, failureCallBack, projectId, displayId) {
        var path = '/api/objectdetection/projects/' + projectId + '/displays/' +  displayId;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    addNewDisplay: function (successCallBack, failureCallBack, projectId, inputDataModel) {
        if (inputDataModel.selectedFile == null) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please pick an image from your computer first." });
            
            failureCallBack(error);

            return;
        }

        if (inputDataModel.displayName.trim().length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for this new display." });
            
            failureCallBack(error);

            return;
        }

        if (inputDataModel.warningScore > inputDataModel.passingScore) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please make sure that the Warning Score is less than the Passing Score." });
            
            failureCallBack(error);

            return;
        }
        
        if (inputDataModel.assignedTags.length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please at least assign a tag to the image." });
            
            failureCallBack(error);

            return;
        }

        let formData = new FormData();

        let submittingAssignedTags = [];

        for(var i = 0; i < inputDataModel.assignedTags.length; i++) {
            submittingAssignedTags.push({
                tagId: inputDataModel.assignedTags[i].tagId, 
                tagName: inputDataModel.assignedTags[i].tagName, 
                width: inputDataModel.assignedTags[i].width, 
                height: inputDataModel.assignedTags[i].height, 
                top: inputDataModel.assignedTags[i].top, 
                left: inputDataModel.assignedTags[i].left, 
            });
        }

        let scoreThresholds = [];

        scoreThresholds.push({ minimumScore: 0, colorHexCode: '#dc3545' });
        scoreThresholds.push({ minimumScore: inputDataModel.warningScore, colorHexCode: '#ffc107' });
        scoreThresholds.push({ minimumScore: inputDataModel.passingScore, colorHexCode: '#0d6efd' });

        formData.append('file', inputDataModel.selectedFile);
        formData.append('name', inputDataModel.displayName.trim());
        formData.append('tags', JSON.stringify(submittingAssignedTags));
        formData.append('scoreThresholds', JSON.stringify(scoreThresholds));

        var path = '/api/objectdetection/projects/' + projectId + '/displays';
        modelBase.post(successCallBack, failureCallBack, path, { body: formData });
    },

    updateImageWithTags: function (successCallBack, failureCallBack, projectId, inputDataModel) {

        if (inputDataModel.displayName.trim().length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for this display." });
            
            failureCallBack(error);

            return;
        }

        if (inputDataModel.warningScore > inputDataModel.passingScore) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please make sure that the Warning Score is less than the Passing Score." });
            
            failureCallBack(error);

            return;
        }

        if (inputDataModel.assignedTags.length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please at least assign a tag to the image." });
            
            failureCallBack(error);

            return;
        }

        let formData = new FormData();

        let submittingAssignedTags = [];

        for(var i = 0; i < inputDataModel.assignedTags.length; i++) {
            submittingAssignedTags.push({
                tagId: inputDataModel.assignedTags[i].tagId, 
                tagName: inputDataModel.assignedTags[i].tagName, 
                width: inputDataModel.assignedTags[i].width, 
                height: inputDataModel.assignedTags[i].height, 
                top: inputDataModel.assignedTags[i].top, 
                left: inputDataModel.assignedTags[i].left, 
            });
        }

        let scoreThresholds = [];

        scoreThresholds.push({ minimumScore: 0, colorHexCode: '#dc3545' });
        scoreThresholds.push({ minimumScore: inputDataModel.warningScore, colorHexCode: '#ffc107' });
        scoreThresholds.push({ minimumScore: inputDataModel.passingScore, colorHexCode: '#0d6efd' });

        formData.append('file', inputDataModel.selectedFile);
        formData.append('fileId', inputDataModel.selectedFileId);
        formData.append('name', inputDataModel.displayName.trim());
        formData.append('tags', JSON.stringify(submittingAssignedTags));
        formData.append('scoreThresholds', JSON.stringify(scoreThresholds));

        var path = '/api/objectdetection/projects/' + projectId + '/displays/' + inputDataModel.selectedDisplayId + "/imageandinfo";
        modelBase.post(successCallBack, failureCallBack, path, { body: formData });
    },

    deactivateDisplay: function (successCallBack, failureCallBack, projectId, displayId) {
        var params = {};

        var path = '/api/objectdetection/projects/' + projectId + '/displays/' + displayId + '/deactivate';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },
}




export default displayModel
